import { ProjectMember } from '@awork/features/project/models/project-member.model'
import { Component, computed, input } from '@angular/core'
import type { User } from '@awork/features/user/models/user.model'
import { AvatarComponent } from '../../../../shared/components/avatar/avatar.component'
import { IconButtonComponent } from '../../../../shared/components/icon-button/icon-button.component'
import { UserDisplayNamePipe } from '@awork/_shared/pipes/user-display-name/user-display-name.pipe'

@Component({
  selector: 'aw-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  imports: [AvatarComponent, IconButtonComponent, UserDisplayNamePipe]
})
export class UserAvatarComponent {
  readonly user = input<User | ProjectMember>()
  readonly showLabel = input(true)
  readonly size = input('m')
  readonly classes = input<string>()
  readonly disabled = input(false)

  readonly resolvedUser = computed(() => this.resolveUser())
  readonly image = computed(() => (this.resolvedUser()?.hasImage ? this.resolvedUser().profileImage(30, 30) : ''))

  /**
   * Resolves the user behind a project membership.
   * @withSignal {InputSignal<User | ProjectMember>} user
   * @returns The avatar user.
   */
  private resolveUser() {
    const user = this.user()
    return user instanceof ProjectMember ? user.user : user
  }
}
